
import { defineComponent, PropType } from "vue";
import { sort } from "fast-sort";
import CiButton from "@components/base/button.vue";

export default defineComponent({
  name: "CiUsersProfileQualifications",
  components: { CiButton },
  inject: {
    slug: "userSlug",
  },
  props: {
    items: {
      type: Array as PropType<UsersV2.QualificationItem.ApiResponse[]>,
      default: () => [],
    },
  },
  computed: {
    orderedList(): UsersV2.QualificationItem.ApiResponse[] {
      const base = (date?: Nullable<string>) => (date ? new Date(date) : new Date());
      return sort(this.items).by([{ desc: (qualification) => base(qualification.issue_date) }]);
    },
  },
});
